<div
  [class.disable]="disable"
  class="component-container w-full"
>
  <div
    *ngIf="label"
    class="form-field-label"
  >
    {{ label }}
  </div>
  <div
    class="track flex flex-row bg-[#F6F8FB]
  rounded-full justify-center items-center
  font-work-sans font-medium text-[1.4rem]
  text-cool-grey cursor-pointer w-full"
  >
    <div
      (click)="handleClick(true)"
      [class.selected]="selectedValue"
      class="button1 w-1/2 flex flex-row justify-center items-center"
    >
      {{ labelTrue }}
    </div>
    <div
      (click)="handleClick(false)"
      [class.selected]="!selectedValue"
      class="button2 w-1/2 flex flex-row justify-center items-center"
    >
      {{ labelFalse }}
    </div>
  </div>
</div>

